/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".review-move__message[_ngcontent-%COMP%]{height:150px;overflow:hidden}"];
export { styles as styles };
